import React from 'react';
import { Box, Typography } from '@mui/material';
import { SanityNavItem } from 'src/types/sanity/types.sanity.navItems';
import { Link } from 'gatsby';

interface TopNavItemsProps {
  navItems: SanityNavItem[] | null;
}

const TopNavItems = ({ navItems }: TopNavItemsProps) => {
  if (!navItems) return null;

  return (
    <>
      <Box
        display={'flex'}        
        width={'100%'}
        justifyContent={'space-between'}
        maxWidth={[undefined, undefined, '680px', '750px']}
        px={'1rem'}                
      >
        {navItems.map(navItem => {
          const { route } = navItem;

          return (
            <>
              <Typography
                component={navItem?.route?.link ? 'a' : Link}
                variant={'body2'}
                // href={navItem?.route?.link}
                href={route?.link}
                to={route?.page?.slug?.current ? `/${route?.page?.slug?.current}` : route?.path}
                sx={{
                  position: 'relative',
                  textDecoration: 'none',
                  color: 'inherit',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: '-20px', // Adjust the offset as needed
                    height: '3px',
                    backgroundColor: 'transparent',
                    transition: 'background-color 0.3s ease',
                  },
                  '&:hover::after': {                    
                    backgroundColor: 'primary.main', // The hover effect border color
                  },
                }}
              >
                {navItem?.name}
              </Typography>
            </>
          );
        })}
      </Box>
    </>
  );
};

export default TopNavItems;
